import { GET_VEHICLE_ICON } from "../actions/types";

const initialState = {
  VehicleIcon: [],
};

const VehicleIconReducerByID = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_VEHICLE_ICON:
      return {
        ...state,
        VehicleIcon: payload,
      };
    default:
      return state;
  }
};

export { VehicleIconReducerByID };
